import { ADVANTAGES } from "@/lib/data";

export default function Advantage() {
  return (
    <section id="advantage" data-testid="advantage-section" className="border-b border-damita-border bg-damita-surface">
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16 py-16 md:py-24 lg:py-32">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-10 md:mb-16">
          <div>
            <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-damita-ink2 mb-6 flex items-center gap-3">
              <span className="w-8 tick-line" /> The BB Power Advantage
            </div>
            <h2 className="font-display font-black text-3xl md:text-4xl lg:text-5xl tracking-tighter leading-[0.95] max-w-3xl">
              Why partner with us
            </h2>
          </div>
          <p className="max-w-md text-damita-ink2 text-base md:text-lg">
            Five reasons enterprise, government and PSU customers entrust their
            mission-critical power infrastructure to BB Power.
          </p>
        </div>

        <div className="grid grid-cols-12 gap-px bg-damita-border border border-damita-border">
          {ADVANTAGES.map((a, i) => (
            <div
              key={a.no}
              data-testid={`advantage-${a.no}`}
              className={`bg-white p-6 md:p-8 transition-all hover:bg-damita-blue hover:text-white group ${
                i === 0 ? "col-span-12 md:col-span-6 lg:col-span-6 row-span-2" : "col-span-12 md:col-span-6 lg:col-span-3"
              }`}
            >
              <div className="flex items-start justify-between mb-6">
                <span className="font-mono text-xs uppercase tracking-[0.22em] text-damita-ink2 group-hover:text-damita-yellow">/ {a.no}</span>
                <span className="w-2 h-2 bg-damita-blue group-hover:bg-damita-yellow" />
              </div>
              <h3 className="font-display font-bold text-xl md:text-2xl tracking-tight mb-3">{a.title}</h3>
              <p className="text-sm md:text-base leading-relaxed text-damita-ink2 group-hover:text-zinc-300">{a.body}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
